"use client";
import { Link } from "@labs/schema";
import { useRive } from "@rive-app/react-canvas";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import React from "react";
import { useIntl } from "../../../utils/intl";
import BackLink from "../../Molecules/BackLink";
export function Header(props) {
    var _props_currentPage = props.currentPage, localizations = _props_currentPage.localizations, backLink = _props_currentPage.backLink;
    var activeLinkClass = "!text-purple";
    var intl = useIntl();
    var avoidAnimation = useReducedMotion();
    var RiveComponent = useRive({
        src: "/images/al_logo_mixed_color.riv",
        autoplay: avoidAnimation ? false : true
    }).RiveComponent;
    return /*#__PURE__*/ React.createElement("header", {
        className: "pt-14 md:pt-9 lg:pt-16 mob:pb-28"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-white relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center pb-4 md:pb-14 h-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex pl-[30px] md:pl-[44px]"
    }, localizations === null || localizations === void 0 ? void 0 : localizations.map(function(Localization, index) {
        return /*#__PURE__*/ React.createElement(Link, {
            href: Localization.link,
            key: index,
            className: "small mb-0 text-black transition hover:text-purple mr-2.5 z-10",
            activeClassName: activeLinkClass
        }, /*#__PURE__*/ React.createElement("span", {
            "aria-hidden": true
        }, Localization.label), /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, Localization.label === "DE" ? "Deutsch" : "English"));
    })), /*#__PURE__*/ React.createElement(Link, {
        href: intl.locale === "de" ? "/de" : "/",
        className: "absolute top-0 left-1/2 -translate-x-1/2 text-center flex justify-center"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Home"), /*#__PURE__*/ React.createElement(RiveComponent, {
        "aria-label": "Amazee Labs",
        role: "img",
        className: "w-64 h-10 mt-20 md:mt-[1.35rem] lg:mt-0"
    }))), /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, backLink ? /*#__PURE__*/ React.createElement(motion.div, {
        initial: avoidAnimation ? {
            opacity: 1,
            x: 0
        } : {
            opacity: 0,
            y: -50
        },
        animate: {
            opacity: 1,
            y: 0
        },
        exit: avoidAnimation ? {
            opacity: 1,
            x: 0
        } : {
            opacity: 0,
            y: -50
        },
        transition: {
            type: "spring",
            mass: 0.35,
            stiffness: 75,
            duration: 0.3
        },
        className: "mt-1 lg:mt-2 mob:absolute mob:-top-4 mob:inset-x-0 mob:mx-auto mob:text-center mob:max-w-[190px]"
    }, /*#__PURE__*/ React.createElement(BackLink, {
        link: backLink.link,
        label: backLink.label
    })) : null)));
}
